import axios, { AxiosResponse } from 'axios';
import { IFilter } from './filterTypes';
import { authApiV2 } from '../../axiosWrapper';

export const addFilterApi = async (filter: IFilter, teamId: number | null, subscriptionId: number): Promise<number> => {
    try {
        const endpoint = '/filters/add-filter';
        const response: AxiosResponse<number> = await authApiV2.post(endpoint, {
            name: filter.name,
            teamId,
            subscriptionId,
            sectorFilter: filter.sectorFilter,
            ownershipFilter: filter.ownershipFilter
        });
        return response.data;
    } catch (error) {
        handleAxiosError(error, 'Failed to add filter');
        throw error;
    }
};

export const updateFilterApi = async (filter: IFilter, teamId: number | null) => {
    try {
        const endpoint = '/filters/update-filter';
        await authApiV2.put(endpoint, {
            id: filter.id,
            name: filter.name,
            teamId,
            sectorFilter: filter.sectorFilter,
            ownershipFilter: filter.ownershipFilter
        });
    } catch (error) {
        handleAxiosError(error, `Failed to update filter with id ${filter.id}`);
    }
};

export const getFiltersApi = async (teamId: number, subscriptionId: number): Promise<IFilter[]> => {
    try {
        const endpoint = '/filters';
        const response: AxiosResponse<IFilter[]> = await authApiV2.get(endpoint, { params: { teamId, subscriptionId } });
        return response.data;
    } catch (error) {
        handleAxiosError(error, 'Failed to get filters');
        throw error;
    }
};

export const getFilterApi = async (id: number): Promise<IFilter> => {
    try {
        const endpoint = '/filter';
        const response: AxiosResponse<IFilter> = await authApiV2.get(endpoint, { params: { id } });
        return response.data;
    } catch (error) {
        handleAxiosError(error, 'Failed to get filter');
        throw error;
    }
};

export const deleteFilterApi = async (id: number) => {
    try {
        const endpoint = `/filters/${id}/delete`;
        await authApiV2.delete(endpoint);
    } catch (error) {
        handleAxiosError(error, `Failed to delete filter with id ${id}`);
    }
};

export const handleAxiosError = (error: unknown, defaultMessage: string) => {
    if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.message || error.response?.statusText || error.message;
        console.error(errorMessage); // Log error for debugging
        throw new Error(errorMessage || defaultMessage || 'An Axios error occurred');
    }
    throw new Error(defaultMessage);
};